import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/9_purple/9_purple"
 * Contains 1 texture(s)
 */
export class Mobile9PurpleAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/9_purple/9_purple';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '9_purple.png'
    ] as const;
}
